/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */
import {
  GET_REMINDERS_SUCCESS,
  GET_REMINDERS_FAILURE,
  ADD_REMINDER_SUCCESS,
  ADD_REMINDER_FAILURE,
  UPDATE_REMINDER_SUCCESS,
  UPDATE_REMINDER_FAILURE,
} from "../actions/actionTypes";

const initialState = {
  reminders: [],
};
export default function (state = initialState, action) {
  switch (action.type) {
    case GET_REMINDERS_SUCCESS:
      return {
        getRemindersSuccess: true,
        reminders: action.payload.reminders,
      };
    case GET_REMINDERS_FAILURE:
      return {
        getRemindersSuccess: false,
        reminders: state.reminders,
        errors: action.payload.message,
      };

    case UPDATE_REMINDER_SUCCESS:
      const indx = state.reminders.findIndex(
        (n) => n._id === action.payload.reminder._id
      );
      if (action.payload.type === "moveReminder" && indx > -1)
        state.reminders[indx] = action.payload.reminder;
      if (action.payload.type === "remove" && indx > -1)
        state.reminders.splice(indx, 1);
      if (action.payload.type === "markCompleted" && indx > -1)
        state.reminders[indx] = action.payload.reminder;

      return {
        updateReminderSuccess: true,
        reminders: state.reminders,
      };
    case UPDATE_REMINDER_FAILURE:
      return {
        updateReminderSuccess: false,
        reminders: state.reminders,
        errors: action.payload.message,
      };

    case ADD_REMINDER_SUCCESS:
      state.reminders.push(action.payload.reminder);
      return {
        ...state,
        addReminderSuccess: true,
      };
    case ADD_REMINDER_FAILURE:
      return {
        ...state,
        addReminderSuccess: false,
        errors: action.payload.message,
      };

    default:
      return state;
  }
}
